function isFileUrl(url: string): boolean {
  return /^https?:\/\//i.test(url) || url.startsWith("blob:") || url.startsWith("/");
}

/** Direct download (as current `<a download>` behavior). */
export function downloadFileDirect(url: string, filename?: string) {
  if (!isFileUrl(url)) return;
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "";
  a.rel = "noopener noreferrer";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * Prefer native “Save As” picker; on cancel/unsupported/CORS → open in new tab
 * so the user can Save As from the browser.
 */
export async function saveFileAs(url: string, filename?: string) {
  if (!isFileUrl(url)) return;

  const suggested =
    filename?.trim() ||
    url.replace(/\\/g, "/").split("/").pop()?.split("?")[0] ||
    "file";

  try {
    const picker = (
      window as Window & {
        showSaveFilePicker?: (opts?: {
          suggestedName?: string;
        }) => Promise<FileSystemFileHandle>;
      }
    ).showSaveFilePicker;

    if (typeof picker === "function") {
      const handle = await picker({ suggestedName: suggested });
      const res = await fetch(url, { credentials: "omit", mode: "cors" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const contentType = (res.headers.get("content-type") || "").toLowerCase();
      if (contentType.includes("text/html")) {
        throw new Error("html body");
      }
      const blob = await res.blob();
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();
      return;
    }
  } catch (err: unknown) {
    const name =
      err && typeof err === "object" && "name" in err
        ? String((err as { name: string }).name)
        : "";
    if (name === "AbortError") return; // user cancelled picker
  }

  // Fallback: new tab — browser “Save As…” / preview
  window.open(url, "_blank", "noopener,noreferrer");
}
